import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginFormWrapper from "./screens/Login/LoginFormWrapper";
import UserListingWrapper from "./screens/User/List/UserListingWrapper";
import FranchiseListingWrapper from "./screens/Franchise/List/FranchiseListingWrapper";
import AdvancePaymentListingWrapper from "./screens/AdvancePayments/List/AdvancePaymentListingWrapper";
import PaymentListingWrapper from "./screens/Payment/List/PaymentListingWrapper";
import PaymentModeListingWrapper from "./screens/PaymentMode/List/PaymentModeListingWrapper";
import CourseListingWrapper from "./screens/Course/List/CourseListingWrapper";
import LevelListingWrapper from "./screens/Level/List/LevelListingWrapper";
import SubjectListingWrapper from "./screens/Subject/List/SubjectListingWrapper";
import FacultyListingWrapper from "./screens/Faculty/List/FacultyListingWrapper";
import ModeListingWrapper from "./screens/Mode/List/ModeListingWrapper";
import DashboardWrapper from "./screens/Dashboard/DashboardWrapper";
import OfflineOrderListingWrapper from "./screens/OfflineOrders/List/OfflineOrderListingWrapper";
import AddOfflineOrderWrapper from "./screens/OfflineOrders/Add/AddOfflineOrderWrapper";
import CourseTypeListingWrapper from "./screens/CourseType/List/CourseTypeListingWrapper";
import AttemptListingWrapper from "./screens/Attempt/List/AttemptListingWrapper";
import ViewOfflineOrderLayout from "./screens/OfflineOrders/View/ViewOfflineOrderLayout";
import BookDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/BookDetails/BookDetailsFormWrapper";
import OrderDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/OrderDetails/OrderDetailsFormWrapper";
import PaymentDetailsFormWrapper from "./screens/OfflineOrders/View/Tabs/PaymentDetails/PaymentDetailsFormWrapper";
import { v4 as uuid } from "uuid";
import AuthHOC from "./AuthHOC";
import PageNotFound from "./PageNotFound";
import TicketViewLayout from "./screens/Franchise/View/TicketViewLayout/TicketViewLayout";
import FranchiseOrdersListingWrapper from "./screens/Franchise/View/FranchiseOrders/FranchiseOrdersListingWrapper";
import FranchiseLedgerListingWrapper from "./screens/Franchise/View/FranchiseLedger/FranchiseLedgerWrapper";
import ReceiptComponent from "./screens/Receipt/receipt";
import ReceiptDownload from "./screens/Receipt/DownloadReceipt";
import BooksListingWrapper from "./screens/Books/List/BooksListingWrapper";
import ProductListingWrapper from "./screens/Product/List/ProductListingWrapper";
import AmountListingWrapper from "./screens/Drawer/List/DrawerAmountListingWrapper";
import DrawerOutFlowFormWrapper from "./screens/Drawer/InOutFlow/DrawerOutFlowWrapper";
import DrawerExchangeFormWrapper from "./screens/Drawer/Exchange/DrawerExchangeFormWrapper";
import DrawerInFlowFormWrapper from "./screens/Drawer/InOutFlow/DrawerInFormWrapper";
import StudentListingWrapper from "./screens/Student/List/StudentListingWrapper";
import FuturePurchaseListingWrapper from "./screens/Future Purchase/List/FuturePurchaseListingWrapper";
import FuturePurchaseTicketViewLayout from "./screens/Future Purchase/View/TicketViewLayout/FuturePurchaseTicketViewLayout";
import FuturePurchaseFollowupNoteListingWrapper from "./screens/Future Purchase/View/FuturePurchaseNotes/FuturePurchaseFollowupNoteListingWrapper";
import UserRoleListingWrapper from "./screens/User-Role/List/UserRoleListingWrapper";
import StudentLedgerListingWrapper from "./screens/Student/View/StudentLedger/StudentLedgerWrapper";
import StudentOrdersListingWrapper from "./screens/Student/View/StudentOrders/StudentOrdersListingWrapper";
import StudentTicketViewLayout from "./screens/Student/View/TicketViewLayout/StudentTicketViewLayout";
import DuesListingWrapper from "./screens/Dues/List/DuesListingWrapper";
import CategoryListingWrapper from "./screens/Category/List/CategoryListingWrapper";
import SyllabusListingWrapper from "./screens/Syllabus/List/SyllabusListingWrapper";
import ModuleListingWrapper from "./screens/Module/List/ModuleListingWrapper";
import GroupListingWrapper from "./screens/Group/List/GroupListingWrapper";
import CouponsListingWrapper from "./screens/Coupons/List/CouponsListingWrapper";
import EditProductFormWrapper from "./screens/Product/Edit/EditProductWrapper";
import OrderListingWrapper from "./screens/Order/List/OrderListingWrapper";
import OrderViewLayout from "./screens/Order/View/ViewLayout/OrderViewLayout";
import CMSViewLayout from "./screens/CMS/View/CMSViewLayout/CMSViewLayout";
import CMSContactInfoListingWrapper from "./screens/CMS/ContactInfo/List/CMSContactInfoListngWrapper";
import CMSSocialMediaListingWrapper from "./screens/CMS/SocialMedia/List/CMSSocialMediaListingWrapper";
import CMSBannerListingWrapper from "./screens/CMS/Banners/List/CMSBannerListingWrapper";
import BlogListingWrapper from "./screens/Blog/List/BlogListingWrapper";
import ProductExcelListingWrapper from "./screens/Product/productExcelLogs/ProductLogsListingWrapper";
import { Navigate } from "react-router-dom";
import OrderView from "./screens/Order/View/OrderDetails/OrderView";
import ProductViewLayout from "./screens/Product/View/ViewLayout/ProductViewLayout";
import AddProductWrapper from "./screens/Product/Add/AddProductWrapper";
import InstituteListingWrapper from "./screens/Institute/List/InstituteListingWrapper";
import ADminListingWrapper from "./screens/Admin/List/AdminListingWrapper";
import ModuleProtectedRoute from "./ProtectedRoute";
import { moduleRoutes } from "./Config/moduleRoutes";
import FileManagerListingWrapper from "./screens/FileManager/List/FileListingWrapper";
import BatchTypeListingWrapper from "./screens/Level copy/List/BatchTypeListingWrapper";
const PageRoutes = () => {
  const deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    localStorage.setItem("deviceId", uuid());
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<PageNotFound />} />
          <Route path="/" element={<LoginFormWrapper />} />
          <Route
            path="/user"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/user"]}>
                <AuthHOC component={<UserListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          {/* <Route
            path="/order"
            element={ */}
          {/* // <ModuleProtectedRoute moduleId={moduleRoutes["/admin"]}>
              // <AuthHOC component={<OrderListingWrapper />} />
              // </ModuleProtectedRoute> */}
          {/* }
          /> */}
          {/* <Route
            path="/order/:orderId"
            element={
              // <ModuleProtectedRoute moduleId={moduleRoutes["/admin"]}>
              <AuthHOC component={<OrderViewLayout />} />
              // </ModuleProtectedRoute>
            }
          /> */}

          {/* Orders */}
          <Route
            path="/order"
            element={<AuthHOC component={<OrderListingWrapper />} />}
          />

          <Route
            path="/order/:orderId"
            element={<AuthHOC component={<OrderViewLayout />} />}
          >
            {/* OrderView tab */}
            <Route path="order-view" element={<OrderView />} />
          </Route>

          <Route
            path="/dashboard"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/dashboard"]}>
                <AuthHOC component={<DashboardWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/franchise"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/franchise"]}>
                <AuthHOC component={<FranchiseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/blog"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/blog"]}>
                <AuthHOC component={<BlogListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/franchise/:franchiseId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/franchise"]}>
                <AuthHOC component={<TicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/offline-order"]}>
                  <AuthHOC component={<FranchiseOrdersListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="ledger"
              element={
                <AuthHOC component={<FranchiseLedgerListingWrapper />} />
              }
            />
          </Route>
          <Route
            path="/future-purchase"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/future-purchase"]}>
                <AuthHOC component={<FuturePurchaseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/future-purchase/:futurePurchaseId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/future-purchase"]}>
                <AuthHOC component={<FuturePurchaseTicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="notes"
              element={
                <ModuleProtectedRoute
                  moduleId={moduleRoutes["/future-purchase"]}
                >
                  <AuthHOC
                    component={<FuturePurchaseFollowupNoteListingWrapper />}
                  />
                </ModuleProtectedRoute>
              }
            />
          </Route>

          <Route
            path="/advance-payment"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/advance-payment"]}>
                <AuthHOC component={<AdvancePaymentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<ProductListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product/:productId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<ProductViewLayout />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product/add"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<AddProductWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product/edit/:productId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<EditProductFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product/excel-logs"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<ProductExcelListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/product/view/:productId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/products"]}>
                <AuthHOC component={<EditProductFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/drawer"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<AmountListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/coupons"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/coupons"]}>
                <AuthHOC component={<CouponsListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/cash-in"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerInFlowFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/cash-out"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerOutFlowFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/cash-exchange"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/drawer"]}>
                <AuthHOC component={<DrawerExchangeFormWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/transaction"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/transaction"]}>
                <AuthHOC component={<PaymentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />

          <Route
            path="/institute"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/institute"]}>
                <AuthHOC component={<InstituteListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/batch-type"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/batch-type"]}>
                <AuthHOC component={<BatchTypeListingWrapper/>} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/file-manager"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/file-manager"]}>
                <AuthHOC component={<FileManagerListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/dues"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/dues"]}>
                <AuthHOC component={<DuesListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/student"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/student"]}>
                <AuthHOC component={<StudentListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/student/:studentId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/student"]}>
                <AuthHOC component={<StudentTicketViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/order"]}>
                  <AuthHOC component={<StudentOrdersListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="ledger"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/order"]}>
                  <AuthHOC component={<StudentLedgerListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
          </Route>
          <Route
            path="/offline-order"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/order"]}>
                <AuthHOC component={<OfflineOrderListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/offline-order/add"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/order"]}>
                <AuthHOC component={<AddOfflineOrderWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/offline-order/edit/:orderId"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/order"]}>
                <AuthHOC component={<ViewOfflineOrderLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="order-deatils"
              element={<AuthHOC component={<OrderDetailsFormWrapper />} />}
            />
            <Route
              path="payment-deatils"
              element={<AuthHOC component={<PaymentDetailsFormWrapper />} />}
            />

            <Route
              path="book-deatils"
              element={<AuthHOC component={<BookDetailsFormWrapper />} />}
            />
          </Route>
          <Route
            path="/payment-mode"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/payment-mode"]}>
                <AuthHOC component={<PaymentModeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/course"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/course"]}>
                <AuthHOC component={<CourseListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/course"]}>
                <AuthHOC component={<ADminListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/book"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/book"]}>
                <AuthHOC component={<BooksListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/category"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/category"]}>
                <AuthHOC component={<CategoryListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/syllabus"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/syllabus"]}>
                <AuthHOC component={<SyllabusListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/module"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/module"]}>
                <AuthHOC component={<ModuleListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/group"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/group"]}>
                <AuthHOC component={<GroupListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/level"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/level"]}>
                <AuthHOC component={<LevelListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/user-role"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/user-role"]}>
                <AuthHOC component={<UserRoleListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/subject"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/subject"]}>
                <AuthHOC component={<SubjectListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/faculty"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/faculty"]}>
                <AuthHOC component={<FacultyListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/mode"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/mode"]}>
                <AuthHOC component={<ModeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/course-type"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/course-type"]}>
                <AuthHOC component={<CourseTypeListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route
            path="/attempt"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/attempt"]}>
                <AuthHOC component={<AttemptListingWrapper />} />
              </ModuleProtectedRoute>
            }
          />
          <Route path="/receipt/:id" element={<ReceiptComponent />} />
          <Route path="/download-receipt/:id" element={<ReceiptDownload />} />

          <Route
            path="/cms"
            element={
              <ModuleProtectedRoute moduleId={moduleRoutes["/cms"]}>
                <AuthHOC component={<CMSViewLayout />} />
              </ModuleProtectedRoute>
            }
          >
            <Route
              path="contact-info"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/cms"]}>
                  <AuthHOC component={<CMSContactInfoListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="social-media"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/cms"]}>
                  <AuthHOC component={<CMSSocialMediaListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
            <Route
              path="banners"
              element={
                <ModuleProtectedRoute moduleId={moduleRoutes["/cms"]}>
                  <AuthHOC component={<CMSBannerListingWrapper />} />
                </ModuleProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default PageRoutes;
